module.exports = __webpack_public_path__ + "static/media/The-Meadows-Amendment-5.4632e469.pdf";